<template>
  <div class="integral-mall">
    <div class="integral-title">
      <div class="explain" @click="ruleClick">兑换说明</div>
      <div class="integral" @click="integralDeta">
        <b>{{ integral }}</b>
        <div>企业积分 <van-icon name="arrow" /></div>
      </div>
      <div class="interests">
        <div class="li" v-for="(item, index) in interestsList" :key="index">
          <i></i>
          <span>{{ item }}</span>
        </div>
      </div>
    </div>
    <div class="integral-exchange">
      <span>企业积分第二年将清空，请及时兑换</span>
      <div @click="market">我的兑换</div>
    </div>
    <div class="integral-list">
      <div class="list-title">
        <div class="title-li" @click="commodity">
          <span>商品类别</span>
          <van-icon name="arrow-down" />
        </div>
        <div class="title-li" @click="sortUp">
          <span>积分排序</span>
          <i :class="['sort', isSort ? '' : 'sort-up']"></i>
        </div>
        <div class="title-li" @click="rateUp">
          <span>兑换量排序</span>
          <i :class="['sort', isRate ? '' : 'sort-up']"></i>
        </div>
      </div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="isUpLoading"
          :finished="upFinished"
          @load="onLoad"
          :offset="offset"
          :finished-text="textBottom"
        >
          <div class="list-ul">
            <div
              class="list-li"
              v-for="(item, index) in recordList"
              :key="index"
              @click="details(item.id)"
            >
              <img :src="item.img.ossUrl" alt="" />
              <div class="title">{{ item.goodsName }}</div>
              <div class="money">
                <b>10000积分</b> <span>已兑{{ item.orderCount }}</span>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-popup
      v-model="iShow"
      closeable
      :style="{ height: '75%', width: '80%', padding: '0 0 20px 0' }"
    >
      <div class="popup-content">
        <div>
          1、积分商城可直接用企业账户积分来兑换物品，使用积分兑换产品，即从账户上扣除相应的积分。
        </div>
        <div>
          2、物品兑换成功后，商城通将在5个工作日内安排发货。实物礼品将安排第三方快递发货。
        </div>
        <div>3、所有积分商城消耗的积分，并不影响账户等级。</div>
        <div>4、积分兑换产品属回馈活动，非质量问题恕不退换。</div>
        <div>
          5、如用户所获得的积分被平台发现是通过非正常手段获得，则该用户的积分商城订单将被视为无效订单；该用户账号也会进行封禁处理。
        </div>
      </div>
    </van-popup>
    <van-popup v-model="typePicker" round position="bottom">
      <van-picker
        title=""
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="typePicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { goodsTypeList, entPage, goodsTypeInfo } from '@api/market/index'
import { listUserDetail } from '@api/lishui/integral'
import { getLocalStorage } from '@utils'
import { newSaveRecord, newSaveUVRecord } from '@api/lishui'
export default {
  data() {
    return {
      interestsList: ['多场景覆盖', '积分兑换', '权益保障'],
      iShow: false,
      typePicker: false,
      isSort: true,
      isRate: true,
      columns: [],
      currPage: {
        pageNum: 0,
        pageSize: 10,
        goodsTypeIds: '',
        orderCountSort: 0
      },
      // 分页
      isLoading: false, // 下拉刷新
      isUpLoading: false, // 上拉加载
      upFinished: false, // 上拉加载完毕
      finished: false,
      offset: 100, // 滚动条与底部距离小于 offset 时触发load事件
      textBottom: '没有更多了~',
      recordList: [],
      userInfo: JSON.parse(getLocalStorage('lishuiUserInfo'))
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {},
      integral: ''
    }
  },
  mounted() {
    this.getGoodsTypeList()
    this.getData()
  },
  methods: {
    getData() {
      const params = {
        creditCode: this.userInfo.creditCode,
        mobile: this.userInfo.mobile
      }
      listUserDetail(params).then(res => {
        if (res.data.code === '0000') {
          this.integral = res.data.data.current_point
        }
      })
    },
    // 分页
    // 下拉调用此函数
    onRefresh() {
      setTimeout(() => {
        this.$toast('刷新成功') // 弹出
        this.isLoading = false
      }, 500)
    },
    // 上拉调用此函数
    onLoad() {
      setTimeout(() => {
        this.isUpLoading = false
        this.getList()
      }, 500)
    },
    details(id) {
      this.buriedPoint()
      this.$router.push({
        path: '/market/listDetails',
        query: {
          id: id
        }
      })
    },
    getList() {
      this.currPage.pageNum++
      entPage(this.currPage).then(res => {
        if (res.data) {
          let lists = res.data.data.list || []
          if (lists.length === 0) {
            this.upFinished = true
          } else {
            this.upFinished = false
          }
          for (var i = 0; i < lists.length; i++) {
            this.recordList.push(lists[i]) // 上拉时循环出来这个数组的三条内容，放入datacontent这个数组里，那样就一直拉一直加
          }
        }
      })
    },
    ruleClick() {
      this.buriedPoint()
      this.iShow = true
    },
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.userInfo.creditCode,
        entName: this.userInfo.entName,
        mobile: this.userInfo.mobile
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      newSaveRecord(params).then(res => {})
      newSaveUVRecord(params).then(res => {})
    },
    // 积分明细
    integralDeta() {
      this.buriedPoint()
      this.$router.push({ name: 'integralDetails' })
    },
    // 中介超市列表
    market() {
      this.buriedPoint()
      this.$router.push({ path: '/market/index', query: { name: 1 } })
    },
    // 获取商品类型
    getGoodsTypeList() {
      goodsTypeInfo().then(res => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          const dataList = data.map(value => {
            return {
              id: value.ids,
              text: value.name
            }
          })
          this.columns = [
            {
              id: '',
              text: '全部'
            },
            ...dataList
          ]
        } else {
          Toast(msg)
        }
      })
    },
    // 弹窗事件
    onConfirm(val) {
      this.currPage.goodsTypeIds = val.id
      this.typePicker = false
      this.currPage.pageNum = 0
      this.recordList = []
      this.getList()
    },
    // 积分
    sortUp() {
      if (this.isSort) {
        this.isSort = false
      } else {
        this.isSort = true
      }
    },
    // 兑换量
    rateUp() {
      if (this.isRate) {
        this.isRate = false
        this.currPage.orderCountSort = 1
      } else {
        this.isRate = true
        this.currPage.orderCountSort = 0
      }
      this.currPage.pageNum = 0
      this.recordList = []
      this.getList()
    },
    // 商品类别
    commodity() {
      this.typePicker = true
    }
  }
}
</script>

<style lang="scss" scoped>
.integral-mall {
  padding-bottom: 40px;
  .integral-title {
    height: 200px;
    background: url('../../../../static/images/mall.png') no-repeat;
    background-size: 100%;
    position: relative;
    overflow: hidden;

    .explain {
      position: absolute;
      top: 10px;
      right: 0;
      width: 73px;
      height: 26px;
      line-height: 26px;
      color: rgba(139, 68, 1, 80);
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 1px;
      border-top-left-radius: 14px;
      border-bottom-left-radius: 14px;
      background-color: rgba(255, 255, 255, 0.4);
      text-align: center;
    }
    .integral {
      width: 150px;
      margin: 42px 0 0 15px;
      text-align: center;
      b {
        color: rgba(139, 68, 1, 1);
        font-size: 45px;
        font-weight: 600;
      }
      > div {
        color: rgba(139, 68, 1, 0.8);
        font-size: 16px;
        margin-left: 20px;
      }
    }
    .interests {
      display: flex;
      justify-content: space-around;
      margin-top: 8px;
      padding: 0 20px;

      .li {
        i {
          display: inline-block;
          width: 12px;
          height: 12px;
          margin-right: 5px;
          background: url('../../../../static/images/interests.png') no-repeat;
          background-size: 100%;
        }
        span {
          color: rgba(181, 126, 74, 100);
          font-size: 13px;
        }
      }
    }
  }
  .integral-exchange {
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 1;
    margin-top: -25px;
    height: 105px;
    line-height: 55px;
    padding: 0 16px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    background: linear-gradient(90deg, #ff7400 0%, #ffad00 100%);
    span {
      color: rgba(255, 255, 255, 100);
      font-size: 15px;
    }
    > div {
      width: 71px;
      height: 31px;
      line-height: 31px;
      border-radius: 16px;
      background-color: rgba(255, 255, 255, 1);
      color: rgba(255, 132, 0, 100);
      font-size: 15px;
      text-align: center;
      margin-top: 12px;
    }
  }
  .integral-list {
    min-height: 100px;
    background-color: #fff;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    margin-top: -50px;
    position: relative;
    z-index: 2;
    .list-title {
      padding: 15px 20px;
      font-size: 17px;
      display: flex;
      justify-content: space-between;
      font-weight: 600;
      i {
        margin-top: -5px;
        margin-left: 8px;
        vertical-align: middle;
      }
      .sort {
        display: inline-block;
        width: 14px;
        height: 20px;
        background: url('../../../../static/images/sort.png') no-repeat center
          top 6px;
        background-size: 100%;
        margin-top: -6px;
        margin-left: 6px;
      }
      .sort-up {
        background: url('../../../../static/images/sortLight.png') no-repeat
          center top 6px;
        background-size: 100%;
      }
    }
    .list-ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 0 10px 10px;
      .list-li {
        width: 172px;
        height: 190px;
        box-shadow: 0px 2px 10px 0px rgba(78, 89, 104, 0.09);
        border: 1px solid rgba(236, 242, 250, 1);
        border-radius: 6px;
        padding-bottom: 10px;
        margin-bottom: 10px;
        img {
          width: 100%;
          height: 128px;
          border-radius: 6px;
        }
        .title {
          color: rgba(51, 51, 51, 100);
          font-size: 16px;
          margin: 4px 0 0px 10px;
          width: 90%;
          height: 25px;
          overflow: hidden;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //溢出用省略号显示
          white-space: nowrap;
        }
        .money {
          display: flex;
          justify-content: space-between;
          padding: 4px 8px 20px;
          b {
            color: #ff7601;
            font-size: 16px;
          }
          span {
            color: #999999;
            font-size: 14px;
            margin-top: 2px;
          }
        }
      }
    }
  }
  .popup-content {
    font-size: 16px;
    color: #333333;
    letter-spacing: 2px;
    line-height: 23px;
    padding: 40px 20px 10px;
    > div {
      text-indent: 1em;
      margin-bottom: 5px;
    }
  }
}
/deep/.van-icon-arrow {
  top: 3px;
  left: -4px;
}
/deep/.van-popup__close-icon--top-right {
  top: 10px;
}
</style>
